<template>
  <div class="row-padding random-container" :key="key">
    <div class="main">
      <div class="r-card w-100 h-100 position-relative card-background" :style="{ 'background-image': `url(${image})` }">
        <div class="black-gradient-1 inner filter-blur-4 cont flex-start-center">
          <div class="w-100 cardTitle">
            <div :class="[lang === 'ar' ? 'text-right' : '', 'card-title p-0']" style="margin-bottom: 1rem">
              {{ item.title }}
            </div>
            <div :class="[lang === 'ar' ? 'text-right' : '', 'white-description clamp-2']">
              {{ item.description }}
            </div>
            <div :class="[lang === 'ar' ? 'text-right' : '', 'mt-4']">
              <div :class="[lang === 'ar' ? 'float-right' : '', 'd-flex small-container']">
                <div :class="[lang === 'ar' ? 'ml-2' : 'mr-2', 'read-text']">
                  <span class="read-text"> <a :href="item.link" target="_blank">{{ $t('readMore') }}</a></span>
                </div>
                <div>
                  <img class="read-arrow" src="../../assets/icons/readmore.svg">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'OfferCard',
  props: {
    data: {
      type: Object
    },
    show: Boolean
  },
  data () {
    return {
      item: { title: '', description: '', icon: '', styles: '' },
      lang: this.$lang,
      key: 0,
      image: ''
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.item = this.data
        this.$forceUpdate()
        this.key++
      }
    }
  },
  created () {
    this.item = this.data
    if (this.$store.state.window > 1100) {
      this.image = this.data.icon
    } else {
      this.image = this.data.smallIcon
    }
  },
  mounted () {
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      if (val > 600) {
        this.image = this.data.icon
      } else {
        this.image = this.data.smallIcon
      }
    })
    setTimeout(() => {
      this.$lang === 'ar' ? $('.read-text').css('font-family', 'Mtn-arabic-bold') : $('.read-text').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.card-title').css('font-family', 'Mtn-arabic-bold') : $('.card-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.white-description').css('font-family', 'Mtn-arabic-regular') : $('.white-description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('#random_cards .row.row-padding').css('flex-direction', 'row-reverse') : $('#random_cards .row.row-padding').css('flex-direction', 'row')
      this.$lang === 'ar' ? $('.read-arrow').css('transform', 'rotate(180deg)') : $('.read-arrow').css('transform', 'rotate(0deg)')
    })
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
@import "src/assets/sass/modules/random";

.small-container {
  width: max-content;
}

.row-padding {
  padding: 2rem 2.5rem 3rem 2.5rem;
}

.cardTitle {
  padding-left: 3vw;
  padding-right: 3vw;
  text-align: left;
}

.inner,
.r-card {
  width: 100%;
  height: 100%;
  border-radius: 30px !important;
}

.card-description {
  max-width: 593px;
  font-size: 13px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5 !important;
}

.cont {
  opacity: 0 !important;
}

.cont:hover {
  opacity: 1 !important;
}

// .card-title {
//   transform: translateY(5px);
//   transition: all .4s;
//   max-width: 484px;
//   //max-width: 100%
//   padding-top: 2rem;
//   font-size: 26px;
//   color: $--yellow;
//   //font-family: Mtn-bold
//   overflow: hidden;
//   display: -webkit-box;
//   -webkit-box-orient: vertical;
//   -webkit-line-clamp: 3;
// }
.card-title {
  transform: translateY(5px);
  transition: all .4s;
  max-width: 484px;
  padding-top: 2rem;
  font-size: 26px;
  color: $--yellow;
  word-wrap: break-word;
  white-space: normal;
  overflow: visible;
  display: block;
}

.r-card {
  background-size: cover !important;
  background-position: center !important;
  //background-size: 100% 100% !important;
  border-radius: 30px;
  transition: all .3s;
}

.r-card:hover {
  //background-size: 110% 110% !important;
}

@media screen and (max-width: 480px) {
  .random-container {
    padding: 2rem 15vw 3rem 15vw !important;
  }
}

@media screen and (max-width: 430px) {
  .random-container {
    padding: 2rem 10vw 3rem 10vw !important;
  }
}

@media screen and (max-width: 370px) {
  .random-container {
    padding: 2rem 5vw 3rem 5vw !important;
  }
}</style>
